import classes from './AdnocLogo.module.css';
import AdnocLogoImage from '#assets/adnoc-logo-full.svg?react';

export function AdnocLogo() {
  return (
    <div className={classes.logos}>
      <AdnocLogoImage className={classes.adnocLogoIcon} />
    </div>
  );
}
